<template>
    <div
        ref="o-step-hyphens-text"
        v-html="hyphensWords(text)"
    />
</template>

<script>
import hyphensWords from '../../../utils/mixins/hyphens-words'
export default {
    mixins: [hyphensWords],
    props: {
        text: {
            type: String,
            default: () => ''
        },
        minFontSize: {
            type: Number,
            default: 16
        },
        defaultFontSize: {
            type: Number,
            default: 20
        }
    },
    watch: {
        text: {
            handler: 'changeFontSize',
            immediate: true
        }
    },
    methods: {
        /**
         * we won't brake words if 2 or 4 symbols don't place, we change the font size and words place
         */
        changeFontSize() {
            this.$nextTick(() => {
                const elem = this.$refs['o-step-hyphens-text']
                const elemHeight = elem.offsetHeight
                if (elemHeight > 20) elem.setAttribute("style", `font-size: ${this.minFontSize}px`)
                if (elem.offsetHeight > 20) elem.setAttribute("style", `font-size: ${this.defaultFontSize}px`)
            })
        }
    }

}
</script>
